import { Box, Container, Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { NavigateNext } from "@mui/icons-material";
import { ItemIssueReturnDetails } from "../../components/ItemIssueReturn/ItemIssueReturnDetails";


export const InvReturnDetailsPage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #f9fafc 0%, #f2f5f8 100%)',
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ mb: 3 }}>
          <Breadcrumbs
            separator={<NavigateNext fontSize="small" />}
            aria-label="breadcrumb"
            sx={{ mb: 2 }}
          >
            <Link
              component={RouterLink}
              to="/dashboard"
              underline="hover"
              color="inherit"
            >
              Dashboard
            </Link>
            <Link
              component={RouterLink}
              to="/item-issue-returns"
              underline="hover"
              color="inherit"
            >
              Item Issue Returns
            </Link>
            <Typography color="text.primary">Return Details</Typography>
          </Breadcrumbs>
        </Box>

        <ItemIssueReturnDetails />
      </Container>
    </Box>
  );
};
